import { makeAutoObservable } from 'mobx';

class SearchFilterState {
  constructor() {
    makeAutoObservable(this);
  }

  get state() {
    return {
      ...this.searchBrowserFilterState.state,
      ...this.state_,
    };
  }

  state_ = {};

  setFilter(key, value) {
    this.state_[key] = value;
  }

  resetFilter() {
    this.state_ = {};
  }

  init({ searchBrowserFilterState }) {
    this.searchBrowserFilterState = searchBrowserFilterState;
    this.isInitialized = true;
  }

  destroy() {
    this.isInitialized = false;
    this.resetFilter();
  }
}

export default SearchFilterState;
